import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import {LegalDocumentsApi} from 'Users/api';
import axiosInstance from 'Shared/utilities/axiosInstance';

const legalDocumentsApi = new LegalDocumentsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

export const getLegalDocumentText = (id: string) =>
  legalDocumentsApi.legalDocumentsGet(id, '1', getAxiosConfig()).then(handleResponse);

export const acceptLegalTerms = (userId: string, documentIds: string[]) =>
  legalDocumentsApi.legalDocumentsAccept(userId, '1', documentIds, getAxiosConfig()).then(handleResponse);
